import { CommonModule, Location } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, Signal, signal, WritableSignal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { filter, map, tap } from 'rxjs';
import { BASE_URL, LANGUAGE } from 'src/core-lib/misselaineous/boot.tokens';
import { MediaModule } from 'src/layout/media/media.module';
import { Uuid } from 'src/utils/uuid.util';
import { CustomizerModel, CustomizerRequest, CustomizerResponse } from '../../model';
import { CUSTOMIZER, CustomizerWorkerSubject } from '../../token';
import { CustomizerDialogComponent } from '../customizer-dialog/customizer-dialog.component';

// import { CustomizerUtils } from '../../customizer.util';



@Component({
    selector: 'app-customizer',
    templateUrl: './customizer.component.html',
    styleUrls: ['./customizer.component.scss', './customizer.view.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        CustomizerDialogComponent,
        CommonModule,
        TranslateModule,
        MediaModule,
    ]
})
export class CustomizerComponent implements OnInit {
    uuid = Uuid.create();
    __customizer: CustomizerModel;
    @Input()
    set customizer(customizer: CustomizerModel) {

        if (this.__customizer == null || this.__customizer.product.id.split(',')[0] != customizer.product.id.split(',')[0])
            this._customizer.postMessage({
                customizer: customizer,
                id: this.uuid,
                baseUrl: this.baseUrl,
                catalog: this.catalog
            });
        this.__customizer = customizer;
        this._detector.markForCheck();
    }

    @Output()
    customizerChange: EventEmitter<CustomizerModel> = new EventEmitter<CustomizerModel>();

    loading$: Signal<boolean>;
    response$: Signal<CustomizerResponse>;
    selected$: WritableSignal<FormData>;

    constructor(
        protected _detector: ChangeDetectorRef,
        protected _location: Location,
        protected _router: Router,
        @Inject(CUSTOMIZER)
        protected _customizer: CustomizerWorkerSubject<CustomizerRequest, CustomizerResponse>,
        @Inject(BASE_URL)
        private baseUrl,
        @Inject(LANGUAGE)
        private catalog,
        private _elm: ElementRef<HTMLElement>,
    ) {
        this.selected$ = signal<FormData>(null);
        this.response$ = toSignal(this._customizer.response$.pipe(filter(a => a.id == this.uuid), tap(resp => this.customizerChange.emit(resp.customizer))));
        this.loading$ = toSignal(this._customizer.loading$.pipe(map(a => a[this.uuid])));
    }

    ngOnInit(): void {

    }

    openView(elm: any) {
        let pid = this.__customizer.product.id.split(',')[0]
        this._customizer.postMessage({
            customizer: this.__customizer,
            id: this.uuid,
            baseUrl: this.baseUrl,
            catalog: this.catalog,
            path: [pid]
        });
        this._elm.nativeElement.querySelector('dialog').showModal();
    }
}


